// https://github.com/relay-tools/react-relay-network-modern
import 'regenerator-runtime/runtime';

import {RelayNetworkLayer, urlMiddleware} from 'react-relay-network-modern';
import {Environment, RecordSource, Store} from 'relay-runtime';
import authMiddleware from './authMiddleware';

const RAZZLE_APP_PREFIX = process.env.RAZZLE_APP_PREFIX;
const tokenType__ = 'tokenType';
const accessToken__ = 'accessToken';
const refreshToken__ = 'refreshToken';
const businessContractId__ = 'businessContractId';
const scanContractId__ = 'scanContractId';

export const xContractMiddleware = async (req, next, store) => {
    const businessContractId = store.get(businessContractId__);
    const scanContractId = store.get(scanContractId__);
    const isBusinessRoute = store.getRequestUrl().includes('business');
    const isScanRoute = store.getRequestUrl().includes('scan');
    const isContractByViewerQuery = req.operation.text.includes('contractsByClient');
    const isWhoamiNext = req.operation.text.includes('whoamiNext');
    if (businessContractId && isBusinessRoute && !isContractByViewerQuery && !isWhoamiNext) {
        req.fetchOpts.headers['X-Contract'] = businessContractId;
    }
    if (scanContractId && isScanRoute && !isContractByViewerQuery && !isWhoamiNext) {
        req.fetchOpts.headers['X-Contract'] = scanContractId;
    }
    
    const res = await next(req);

    return res;
};

const refresh = async (refreshToken) => {
    const query = graphql`
      mutation createRelayEnvironmentMutation($request: RefreshRequestInput) {
        refresh(request: $request) {
            tokenType
            accessToken
            refreshToken
        }
      }
    `;
    const variables = {request: {refreshToken}};
    const response = await fetch(`${RAZZLE_APP_PREFIX}/graphql`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json',},
        body: JSON.stringify({query: query.params.text, variables}),
    });
    const {data, errors} = await response.json();
    if (errors) {
        throw new Error(errors[0].message);
    }
    return data.refresh;
};

function ssrContext404Middleware(ssrContext) {
    return (next) => async (req) => {
        try {
            const res = await next(req);
            const {errors} = res;
            if (errors) {
                const errorMessages = errors.map(error => error.message);
                const hasServiceInvalid = errorMessages.some(msg =>
                    msg.startsWith("Service invalid.")
                );
                if (hasServiceInvalid) {
                    ssrContext.statusCode = 404;
                }
            }
            return res;
        } catch (err) {
            if (ssrContext && (err?.message || String(err)).includes('Service invalid')) {
                ssrContext.statusCode = 404;
            }
            throw err;$
        }
    };
}

export default function createRelayEnvironment(headers, store, ssrContext) {
    const RAZZLE_APP_PREFIX = process.env.RAZZLE_APP_PREFIX;
    return new Environment({
        network: new RelayNetworkLayer([
            urlMiddleware({
                url: `${RAZZLE_APP_PREFIX}/graphql`,
                headers
            }),
            // https://auth0.com/blog/refresh-tokens-what-are-they-and-when-to-use-them/
            // https://auth0.com/blog/securing-single-page-applications-with-refresh-token-rotation/
            authMiddleware({
                allowEmptyToken: true,
                token: () => store.get(accessToken__),
                tokenRefreshPromise: async () => {
                  try {
                        const payload = await refresh(store.get(refreshToken__));
                        store.set(tokenType__, payload.tokenType);
                        store.set(accessToken__, payload.accessToken);
                        store.set(refreshToken__, payload.refreshToken);
                        return payload?.accessToken;
                    } catch (err) {
                        return;
                    }
                },
            }),
            ...(ssrContext ? [ssrContext404Middleware(ssrContext)] : []),
            (next) => async (req) => {
                return await xContractMiddleware(req, next, store);
            },
            // , loggerMiddleware()
        ]),
        store: new Store(new RecordSource()),
    });
}
